import { get } from "lodash"
import { createSelector } from "reselect"
import { NORMALIZATION } from "helpers/segments"
import { computeFilterOns } from "helpers/filters/filter-ons"
import { computeChipSecuritiesIds, computeFilterChips } from "helpers/filters/chips"
import { computeEditingFilter, computeAddedFilters } from "helpers/filters"
import { computeClassifications, classificationsMap } from "helpers/classification"
import { computeSecuritiesDescriptors } from "helpers/securities"
import { mapFilters } from "../helpers/filters"
import { getTagCategories, getAttributeCategories, getAssetType } from "modules/portfolio-root/selectors"
import { getCurrency, getViewType } from "modules/portfolio-root/selectors/portfolios"
import { getRebalanceDate } from "."

export const getNormalization = () => NORMALIZATION.CONTRIBUTION
export const getFilter = state => state.modules.rebalance.filter
const getEditing = state => state.modules.rebalance.editingFilter
const getRawClassifications = state => get(state, "global.data.classifications.data.classifications")
const getRawFilters = state => get(state, "global.data.simulatorComposition.data.model.simulation.filters")
const getRawRebalancedFilters = state => get(state, "modules.rebalance.rebalancedFilters")
const getClassificationsValues = state => get(state, "global.data.classificationsValues.data")
const getPortfolioSecuritiesDescriptors = (state) => get(state, "global.data.portfolioSecuritiesDescriptors.data")

const getClassifications = createSelector(
  [getRawClassifications, getRebalanceDate],
  computeClassifications,
)

export const getClassificationsTiers = createSelector(
  [getRawClassifications, getRebalanceDate],
  classificationsMap,
)

export const getSecuritiesDescriptors = createSelector(
  [getPortfolioSecuritiesDescriptors],
  computeSecuritiesDescriptors,
)

const getFilters = createSelector(
  [getRawFilters, getRawRebalancedFilters],
  (filters, rebalancedFilters) => mapFilters(rebalancedFilters || filters),
)

export const getFilterOns = createSelector(
  [getViewType, getFilters, getFilter, getEditing, getTagCategories, getClassifications, getClassificationsValues, getAttributeCategories, getAssetType, getNormalization],
  computeFilterOns,
)

export const getEditingFilter = createSelector(
  [getFilter, getEditing, getFilterOns, getSecuritiesDescriptors],
  computeEditingFilter,
)

export const getChips = createSelector(
  [getFilter, getTagCategories, getClassifications, getSecuritiesDescriptors, getFilters, getAttributeCategories, getClassificationsValues, getCurrency],
  computeFilterChips,
)

export const getSegment = state => state.modules.rebalance.analyticsSegment

export const getChipSecuritiesIds = createSelector(
  [getFilter],
  computeChipSecuritiesIds,
)

export const getAddedFilters = createSelector(
  [getFilter, getFilterOns, getTagCategories, getClassifications, getSecuritiesDescriptors, getFilters, getAttributeCategories, getClassificationsValues, getCurrency],
  (filter, filterOns, tagCategories, classificationsMetas, securitiesDescriptors, portfolioFilters, attributeCategories, classificationsValues, currency) => {
    return computeAddedFilters(filter, filterOns, {
      securitiesDescriptors,
      classificationsInfos: {
        classificationsMetas,
        classificationsValues,
      },
      tagCategories,
      portfolioFilters,
      attributeCategories,
      currency,
    })
  },
)
